import React, { useEffect } from "react";
import useInput from "../../../hooks/useIndicatorInput";
import IsRequiredModule from "./IsRequiredModule";

const EmaEntrySetting = (props) => {
  const { indicator, updateIndicator, isLong,t } = props;

  const [ema1, bindEma1, setEma1] = useInput(indicator.period_num, 0);
  const [ema2, bindEma2, setEma2] = useInput(indicator.value2, 0);

  useEffect(() => {
    setEma1(indicator.period_num);
    setEma2(indicator.value2);
  }, [indicator]);

  useEffect(() => {
    updateIndicator({
      ...indicator,
      period_num: ema1,
      value2: ema2,
    });
  }, [ema1, ema2]);
  return (
    <div>
      <h6>{isLong ? "Long" : "Short"} {t("strategy")}</h6>
      <div>
        <label>{t("long-period")}:</label>
        <input type="number" {...bindEma1} />
      </div>
      <div>
        <label>{t("short-period")}:</label>
        <input type="number" {...bindEma2} />
      </div>
      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </div>
  );
};

export default EmaEntrySetting;
